
import { AccountModule } from '@/store/modules/account.module';
import { defineComponent, computed, useAttrs, watch } from 'vue';

export default defineComponent({
  props: {
    modelValue: {
      type: [Number, String]
    },
    filterRoleNameKey: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const attrs = useAttrs()
    const roleList = computed(() => AccountModule.roleList)
    const roleId = computed({
      get () {
        return props.modelValue
      },
      set (value) {
        emit('update:modelValue', value)
      }
    })

    const showList = computed(() => {
      if (props.filterRoleNameKey.length === 0) {
        return roleList.value
      }
      return roleList.value.filter(role => props.filterRoleNameKey.indexOf(role.nameKey) === -1)
    })

    function handleChange (val) {
      emit('change', val)
    }

    if (roleList.value.length === 0) {
      AccountModule.loadRoleList()
    }
    
    return {
      attrs,
      roleId,
      showList,
      handleChange
    }
  }
})
